import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/product_types',
    name: 'productCategoryPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
